import React, { useMemo, useState } from 'react';
import { IconButton, Box, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Delete, Edit, Visibility } from '@mui/icons-material';

import ConfirmDeleteDialog from '../../components/ConfirmDialog';
import { useTeam } from '../../context/TeamContext';
import AddTeamDialog from './AddTeamDialog';

const TeamManagement = () => {
  // const navigate = useNavigate();
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [confirmDeleteTeam, setConfirmDeleteTeam] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const { teams, addTeam, removeTeam, updateTeam } = useTeam();

  const teamsExcludeAll = useMemo(() => {
    return teams.filter((item) => item.id !== 'settings');
  }, [teams]);

  const handleViewTeamDetail = (team) => {
    setSelectedTeam(team);
    setEditMode(false);
    setOpenTeamModal(true);
  };

  const handleEditTeam = (team) => {
    setSelectedTeam(team);
    setEditMode(true);
    setOpenTeamModal(true);
  };

  const handleSaveTeam = (payload) => {
    updateTeam({
      ...payload,
      id: selectedTeam.id,
    });
    setOpenTeamModal(false);
  };

  const handleCloseModal = () => {
    setSelectedTeam(null);
    setOpenTeamModal(false);
  };

  const handleConfirmDeleteTeam = () => {
    if (confirmDeleteTeam) {
      removeTeam(confirmDeleteTeam.id);
      setConfirmDeleteTeam(null);
    }
  };

  const handleSubmitNewTeam = (payload) => {
    addTeam(payload);
    setOpenTeamModal(false);
  };

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'members', headerName: 'Members', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      width: 130,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ marginLeft: '-8px' }}>
          <IconButton
            color="primary"
            onClick={() => handleViewTeamDetail(params.row)}>
            <Visibility />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleEditTeam(params.row)}>
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => setConfirmDeleteTeam(params.row)}>
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ padding: '20px' }}>
      <Box mb={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenTeamModal(true)}>
          Add New Team
        </Button>
        <AddTeamDialog
          isOpen={openTeamModal}
          team={selectedTeam}
          onClose={handleCloseModal}
          onSubmit={selectedTeam ? handleSaveTeam : handleSubmitNewTeam}
          isViewOnly={!!selectedTeam && !editMode}
        />
      </Box>
      <Box sx={{ minHeight: 600, width: '100%' }}>
        <DataGrid
          rows={teamsExcludeAll}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 20, 50]}
          onPageSizeChange={setPageSize}
          disableSelectionOnClick
          autoHeight
        />
      </Box>

      <ConfirmDeleteDialog
        isOpen={!!confirmDeleteTeam}
        title="Delete Team"
        confirmText={`Are you sure want to remove team "${confirmDeleteTeam?.name}"?`}
        onClose={() => setConfirmDeleteTeam(null)}
        onConfirm={handleConfirmDeleteTeam}
      />
    </Box>
  );
};

export default TeamManagement;
